/**
 * Root reducer.
 * @module reducers/root
 */

import defaultReducers from '@plone/volto/reducers';
import socialNetworks from './socialNetworks';
import footerLinks from './footerLinks';
import authors from './authors';
import bricsReducers from '../api/brics/reducers';

/**
 * Root reducer.
 * @function
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
const reducers = {
  ...defaultReducers,
  ...bricsReducers,
  // Add your reducers here
  socialNetworks,
  footerLinks,
  authors,
};

export default reducers;
